module.exports = __webpack_public_path__ + "img/background-survey-starter.7fcc47fe.jpg";